<template>
  <div class="main">
    <div class="main-desc">
      <div>
        <el-image :src="require('../assets/image/yidesc.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
      </div>
      <div>
        <el-image :src="require('../assets/image/yix.jpg')" class="main-img">
          <div slot="placeholder" class="custom-loading">
            <!-- 这里是你的自定义加载动画 -->
            <i class="el-icon-loading"></i>
          </div>
        </el-image>
        <span class="beian">网站备案号：渝ICP备2024032881号-1</span>
      </div>
    </div>
    <div class="main-con" ref="mBox">
      <div class="main-con-box" ref="yi1">
        <div class="yi-v-box">
          <video muted :class="['yi-video', activeArea ? 'hide' : '']" autoplay>
            <source :src="require('../assets/video/yi/zbj.mp4')" type="video/mp4" />
          </video>
          <video ref="videoye" muted :class="['yi-video yi-v-item', activeArea == 'ye' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/ye.mp4')" type="video/mp4" />
          </video>
          <video ref="videogb" muted :class="['yi-video yi-v-item', activeArea == 'gb' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/gb.mp4')" type="video/mp4" />
          </video>
          <video ref="videogt" muted :class="['yi-video yi-v-item', activeArea == 'gt' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/gt.mp4')" type="video/mp4" />
          </video>
          <video ref="videozg" muted :class="['yi-video yi-v-item', activeArea == 'zg' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/zg.mp4')" type="video/mp4" />
          </video>
          <video ref="videoht" muted :class="['yi-video yi-v-item', activeArea == 'ht' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/ht.mp4')" type="video/mp4" />
          </video>
          <video ref="videozk" muted :class="['yi-video yi-v-item', activeArea == 'zk' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/zk.mp4')" type="video/mp4" />
          </video>
          <video ref="videocg" muted :class="['yi-video yi-v-item', activeArea == 'cg' ? '' : 'hide']">
            <source :src="require('../assets/video/yi/cg.mp4')" type="video/mp4" />
          </video>
        </div>
        <div class="yi-btn-list">
          <el-button class="btn" :type="activeArea == 'ye' ? 'primary' : ''" round size="small" @click="handleAreaClick('ye')">鱼儿</el-button>
          <el-button class="btn" :type="activeArea == 'gb' ? 'primary' : ''" round size="small" @click="handleAreaClick('gb')">滚板</el-button>
          <el-button class="btn" :type="activeArea == 'gt' ? 'primary' : ''" round size="small" @click="handleAreaClick('gt')">篙筒</el-button>
          <el-button class="btn" :type="activeArea == 'zg' ? 'primary' : ''" round size="small" @click="handleAreaClick('zg')">综杆</el-button>
          <el-button class="btn" :type="activeArea == 'ht' ? 'primary' : ''" round size="small" @click="handleAreaClick('ht')">花筒</el-button>
          <el-button class="btn" :type="activeArea == 'zk' ? 'primary' : ''" round size="small" @click="handleAreaClick('zk')">竹筘</el-button>
          <el-button class="btn" :type="activeArea == 'cg' ? 'primary' : ''" round size="small" @click="handleAreaClick('cg')">踩棍</el-button>
        </div>
        <div class="gotoarrow" v-on:click="gotoYi(2)">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="main-con-box" ref="yi2">
        <div class="gotoarrow gototop" v-on:click="gotoYi(1)">
          <i class="el-icon-arrow-down"></i>
        </div>
        <div class="yi2-row" style="height: 330px; justify-content: center">
          <div class="yi2-item" @click="handleYiClick(1)">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi1.jpg')" :class="activeYi == '1' ? 'hide' : ''">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <div class="dian-pro" v-if="tishi"></div>
            <video ref="videoyi1" muted :class="['yi2-video', activeYi == '1' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi1.mp4')" type="video/mp4" />
            </video>
          </div>
          <div class="yi2-item" @click="handleYiClick(2)">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi2.jpg')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi2" muted :class="['yi2-video', activeYi == '2' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi2.mp4')" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="yi2-row" style="height: 354px; justify-content: center">
          <div class="yi2-item" @click="handleYiClick(3)">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi3.jpg')" :class="activeYi == '3' ? 'hide' : ''">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi3" muted :class="['yi2-video', activeYi == '3' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi3.mp4')" type="video/mp4" />
            </video>
          </div>
          <div class="yi2-item" @click="handleYiClick(4)">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi4.jpg')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi4" muted :class="['yi2-video', activeYi == '4' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi4.mp4')" type="video/mp4" />
            </video>
          </div>
          <div class="yi2-item" @click="handleYiClick(5)">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi5.jpg')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi5" muted :class="['yi2-video', activeYi == '5' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi5.mp4')" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="yi2-row" style="height: 330px; justify-content: center">
          <div class="yi2-item" @click="handleYiClick(6)" style="margin-left: 102px">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi6.jpg')" :class="activeYi == '6' ? 'hide' : ''">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi6" muted :class="['yi2-video', activeYi == '6' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi6.mp4')" type="video/mp4" />
            </video>
          </div>
          <div class="yi2-item" @click="handleYiClick(7)" style="margin-left: 30px">
            <el-image fit="contain" class="yi-img" :src="require('../assets/video/yi2/yi7.jpg')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
            <video ref="videoyi7" muted :class="['yi2-video', activeYi == '7' ? '' : 'hide']">
              <source :src="require('../assets/video/yi2/yi7.mp4')" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {EventBus} from '../utils/eventBus.js'
export default {
  name: 'Yi',
  data() {
    return {
      tishi: true,
      activeArea: '',
      activeYi: ''
    }
  },
  mounted() {
    let container = this.$refs.mBox
    var pages = this.$refs.mBox.querySelectorAll('.main-con-box')
    let axis = 0
    function handleScroll(event) {
      event.preventDefault()
      var delta = event.deltaY || event.detail || -event.wheelDelta
      axis += delta
      if (Math.abs(axis) < 300) {
        return false
      }
      axis = 0
      var scrollHeight = container.scrollHeight - container.clientHeight
      var scrollTop = container.scrollTop
      var scrollPercentage = (scrollTop / scrollHeight) * 100
      var currentStep = Math.floor(scrollPercentage / (100 / (pages.length - 1)))
      var nextStep = delta > 0 ? currentStep + 1 : currentStep - 1
      if (nextStep >= 0 && nextStep < pages.length) {
        var nextPage = pages[nextStep]
        scrollToPage(nextPage)
      } else if (nextStep < 0) {
        var firstPage = pages[0]
        scrollToPage(firstPage)
      } else if (nextStep >= pages.length) {
        var lastPage = pages[pages.length - 1]
        scrollToPage(lastPage)
      }
    }

    function scrollToPage(page) {
      var pageOffsetTop = page.offsetTop
      var containerOffsetTop = container.offsetTop
      var offset = pageOffsetTop - containerOffsetTop

      container.scrollTo({
        top: offset,
        behavior: 'smooth'
      })
    }

    container.addEventListener('wheel', handleScroll)
    container.addEventListener('touchmove', handleScroll)
  },
  methods: {
    gotoYi(i) {
      let container = this.$refs.mBox
      var page = this.$refs['yi' + i]

      var pageOffsetTop = page.offsetTop
      var containerOffsetTop = container.offsetTop
      var offset = pageOffsetTop - containerOffsetTop
      container.scrollTo({
        top: offset,
        behavior: 'smooth'
      })
    },
    handleAreaClick(area) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      if (this.activeArea) {
        this.$refs['video' + this.activeArea].currentTime = 0
      }
      this.activeArea = area
      this.$refs['video' + area].play()
    },
    handleYiClick(id) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.tishi = false
      this.$refs['videoyi' + id].currentTime = 0
      this.activeYi = id
      this.$refs['videoyi' + id].play()
    }
  }
}
</script>
<style lang="scss" scoped>
.main-con {
  overflow: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .main-con-box {
    flex-shrink: 0;
    height: 100%;
    position: relative;
    .gotoarrow {
      &.gototop {
        top: 10px;
        bottom: auto;
        z-index: 2;
        i {
          transform: rotate(180deg);
        }
      }
      &:hover {
        color: #595757;
      }
      cursor: pointer;
      width: 100%;
      position: absolute;
      bottom: -10px;
      text-align: center;
      animation: bounce-inSS 1.6s infinite; /* 启动动画特效 */
      i {
        font-size: 30px;
      }
    }
  }
}
@keyframes bounce-inSS {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-16px);
  }
  60% {
    transform: translateY(-6px);
  }
}
@keyframes bounce-inSS2 {
  0%,
  20%,
  50%,
  80%,
  100% {
    opacity: 0;
    transform: scale(1);
  }
  40% {
    opacity: 0.6;
    transform: scale(1.2);
  }
  60% {
    opacity: 0.7;
    transform: scale(1.3);
  }
}
.yi-v-box {
  height: calc(100% - 100px);
  position: relative;
  .yi-video {
    height: 100%;
    width: auto;
    &.yi-v-item {
      position: absolute;
      left: 0;
      top: 0;
    }
    &.hide {
      visibility: hidden;
    }
  }
}

.yi-btn-list {
  text-align: center;
  margin-top: 40px;
  .btn {
    min-width: 120px;
    text-align: center;
  }
}

.yi2-row {
  display: flex;
  .yi2-item {
    height: 100%;
    position: relative;
    .dian-pro {
      position: absolute;
      width: 32px;
      height: 32px;
      z-index: 2;
      border-radius: 50%;
      top: 62%;
      left: 65%;
      background-color: rgba($color: #fff, $alpha: 0.6);
      animation: bounce-inSS2 2s infinite; /* 启动动画特效 */
    }
    .yi-img {
      height: 100%;
      width: auto;
      cursor: pointer;
    }
    .yi2-video {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .hide {
      visibility: hidden;
    }
  }
}
</style>
